import { PolicyIO } from "../common.model";
import { PolicyDO } from "../policy.model";
import { ClientDO } from "../client.model";
import { clientReducer } from "../../reducer/client.reducer";
import { ProposalIO } from "../common.model";

export const initialState ={
    payload: {}
}

export interface AppState {
    readonly payload : ProposalIO;
  }

  export const initialClientState ={
    payload: {}
  }

  export const globalAppReducer = {
    clientStore: clientReducer
  };